import { Col, Form, Modal, Row } from "react-bootstrap";
import { Button } from "../../../../components/Formularios/Buttons/Button";
import { mdiCheckCircle, mdiKeyboardReturn } from "@mdi/js";
import { useEffect } from "react";
import { Switch, TextField } from "@mui/material";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";

interface DetalheFormData {
  codigo: string;
  descricao: string;
  ativo: boolean;
  defUsuario01?: string;
  defUsuario02?: string;
  defUsuario03?: string;
  defUsuario04?: string;
  defUsuario05?: string;
  defUsuario06?: string;
}

interface DetalheModalProps {
  showModal: boolean;
  acao?: string;
  onClose: () => void;
  dadosCodigo?: string;
  dadosDescricao?: string;
  dadosAtivo?: boolean;
  dadosDefUsuario01?: string;
  dadosDefUsuario02?: string;
  dadosDefUsuario03?: string;
  dadosDefUsuario04?: string;
  dadosDefUsuario05?: string;
  dadosDefUsuario06?: string;
  onSubmit: (formData: any) => void;
}

const ModalDetalhe: React.FC<DetalheModalProps> = ({
  showModal,
  acao,
  onClose,
  dadosCodigo,
  dadosDescricao,
  dadosAtivo,
  dadosDefUsuario01,
  dadosDefUsuario02,
  dadosDefUsuario03,
  dadosDefUsuario04,
  dadosDefUsuario05,
  dadosDefUsuario06,
  onSubmit,
}) => {
  const { register, handleSubmit, setValue, watch, reset } = useForm<DetalheFormData>({
    defaultValues: {
      codigo: "",
      descricao: "",
      ativo: true,
      defUsuario01: "",
      defUsuario02: "",
      defUsuario03: "",
      defUsuario04: "",
      defUsuario05: "",
      defUsuario06: "",
    }
  });

  const carregarDados = () => {
    reset({
      codigo: dadosCodigo || "",
      descricao: dadosDescricao || "",
      ativo: dadosAtivo === true,
      defUsuario01: dadosDefUsuario01 || "",
      defUsuario02: dadosDefUsuario02 || "",
      defUsuario03: dadosDefUsuario03 || "",
      defUsuario04: dadosDefUsuario04 || "",
      defUsuario05: dadosDefUsuario05 || "",
      defUsuario06: dadosDefUsuario06 || "",
    });
  };

  useEffect(() => {
    if (showModal) {
      carregarDados();
    }
  }, [showModal]);

  const handleFormSubmit = (data: DetalheFormData) => {
    onSubmit({
      ...data,
      acao,
    });
  };
  
  return (
    <>
      <Modal
        show={showModal}
        className="modal-full-width"
        size="xl"
        keyboard={false}
        centered
      >
        <Modal.Header className="bg-white">
          <Modal.Title>Incluir Código do Sistema</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit(handleFormSubmit)}>
          <Modal.Body className="bg-white">
            <Box sx={{ width: "100%" }}>
              <Row>
                <Col sm={2}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Código"
                    size="small"
                    {...register("codigo", { required: true })}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                    disabled={acao === "Visualizar" || acao === "EditarItem"}
                    inputProps={{
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                </Col>
                <Col sm={8}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Descrição"
                    size="small"
                    {...register("descricao", { required: true })}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                    disabled={acao === "Visualizar"}
                    inputProps={{
                      style: { textTransform: 'capitalize' }
                    }}
                  />
                </Col>
                <Col sm={2}>
                  <label htmlFor="" className="form-label me-2">
                    Ativo
                  </label>
                  <Switch
                    checked={watch("ativo")}
                    onChange={(e) => setValue("ativo", e.target.checked)}
                    disabled={acao === "Visualizar"}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Def. Usuário 01"
                    size="small"
                    {...register("defUsuario01")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={acao === "Visualizar"}
                  />
                </Col>
                <Col sm={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Def. Usuário 02"
                    size="small"
                    {...register("defUsuario02")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={acao === "Visualizar"}
                  />
                </Col>
                <Col sm={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Def. Usuário 03"
                    size="small"
                    {...register("defUsuario03")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={acao === "Visualizar"}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Def. Usuário 04"
                    size="small"
                    {...register("defUsuario04")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={acao === "Visualizar"}
                  />
                </Col>
                <Col sm={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Def. Usuário 05"
                    size="small"
                    {...register("defUsuario05")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={acao === "Visualizar"}
                  />
                </Col>
                <Col sm={4}>
                  <TextField
                    sx={{ width: "100%", mb: 3 }}
                    id="outlined-basic"
                    label="Def. Usuário 06"
                    size="small"
                    {...register("defUsuario06")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={acao === "Visualizar"}
                  />
                </Col>
              </Row>
            </Box>
          </Modal.Body>
          <Modal.Footer className="bg-white">
            <div className="d-flex my-2 gap-1 justify-content-between">
              <Button
                type="button"
                className="btn btn-light text-danger bg-white border-0"
                descricaoBotao="Voltar"
                icone={mdiKeyboardReturn}
                onclick={onClose}
              />
              <Button
                type="submit"
                className="btn btn-light text-info-emphasis bg-white border-0"
                descricaoBotao="Salvar"
                icone={mdiCheckCircle}
              />
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};
export default ModalDetalhe;
